import { createContext } from 'react';

const FAQsContext = createContext();
export default FAQsContext;
